import { Component, ChangeDetectionStrategy, signal, computed, effect, inject, ChangeDetectorRef, OnInit, OnDestroy, Signal, HostListener, ViewChild } from '@angular/core';
import { CommonModule, CurrencyPipe, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProductService } from '../../services/product.service';
import { KsNetService } from '../../services/ksNet.service';
import { CartItem } from '../../types/product';
import { ProductListComponent } from '../product-list/product-list.component';
import { CartComponent } from '../cart/cart.component';
import { MemberSearch } from './member-search/member-search'
import { MasterService } from '@/src/services/master.service';
import { WebSocketService } from '@/src/services/webSocket.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Constants } from '@/src/helpers/constants';
import { InputTextModule } from 'primeng/inputtext';
import { AuthenticationService } from '@/src/services/authentication.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { PhoneFormatPipe } from '../../pipes/phone-format-pipe'
import { DialogModule } from 'primeng/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { InputMaskModule } from 'primeng/inputmask';
import { filter, Subject } from 'rxjs';
import { ToastModule } from 'primeng/toast';

// type PaymentMethod = 'Card' | 'Cash' | 'EasyPay' | 'Points';
type ViewMode = 'register' | 'payment';
type PaymentStep = 'selection' | 'card' | 'cash' | 'easypay' | 'points' | 'complete';
interface Group {
  code: string;
  name: string;
  sr_tp: string;
}
@Component({
  selector: 'app-pos',
  standalone: true,
  imports: [InputNumberModule, FormsModule, ProductListComponent, CartComponent, TranslateModule, MemberSearch, CommonModule,
    InputTextModule, PhoneFormatPipe, DialogModule, InputMaskModule, ToastModule],
  templateUrl: './pos.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PosComponent implements OnInit, OnDestroy {
  productService = inject(ProductService);
  masterService = inject(MasterService);
  translate = inject(TranslateService);
  auth = inject(AuthenticationService);
  cdr = inject(ChangeDetectorRef);
  route = inject(ActivatedRoute);
  ksNet = inject(KsNetService)
  router = inject(Router)
  webSocket = inject(WebSocketService)
  openMemberSearch = signal(false);
  member = signal<any | null>(null);
  RECV_AMT: number = 0;
  Change_AMT: number = 0;
  mon_cnt: string = '00'
  paymentType = Constants.paymentType;

  // State Signals
  products = signal<any[]>([]);
  cart = signal<CartItem[]>([]);

  viewMode = signal<ViewMode>('register');
  paymentStep = signal<PaymentStep>('selection');
  selectedPaymentMethod = signal<number>(Constants.paymentType.Cash);

  selectedCategory = signal<any>(null);
  selectedGroup = signal<any>(null);

  processingPayment = signal(false);
  searchTerm = signal('');
  isDataLoading = signal(false);
  isMobileCartExpanded = signal(false);
  countdown = signal(10);
  selectedProductForModal = signal<any | null>(null);
  cartTemp = signal<any>(null)

  private countdownInterval: any;

  posTabs = signal<any[]>([]);

  isPaymentTemp: boolean = false;

  constructor() {
    effect((onCleanup) => {
      if (this.paymentStep() === 'complete') {
        this.countdown.set(10);
        this.countdownInterval = setInterval(() => {
          this.countdown.update(c => {
            if (c <= 1) {
              clearInterval(this.countdownInterval);
              this.handleCompleteClose();
              return 0;
            }
            return c - 1;
          });
        }, 1000);
      }
      onCleanup(() => {
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
        }
      });
    });
  }

  reservationDt: string = '';
  reservationNo: string = '';
  ngOnInit() {
    this.cart.set([])
    this.getStoreInfo();
    this.route.queryParamMap.subscribe(params => {
      this.reservationDt = params.get('reservatioN_DT') || '';
      this.reservationNo = params.get('reservatioN_NO') || '';
    });
    const userId = this.auth.getUserId()
    this.selectedUser.set(userId);
    this.loadData();
    this.getMemberLvl();

    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe((event: NavigationEnd) => {
    //     this.onSaveCartTemp();
    //   });
  }

  async showConfirmCart() {
    const result = await this.masterService.showCartTemp();

    if (result) {
      this.onContinue();
    }
  }

  onContinue() {
    if (this.cartTemp()?.length > 0) {
      this.isPaymentTemp = true;
      this.cart.set([]);
      this.cartTemp().forEach((element: any) => {
        this.addToCartTemp(element);
      });
      if (this.cartTemp()[0]?.membeR_NO) {
        this.getMemberReservation(this.cartTemp()[0].membeR_NO);
      }
    }
  }

  onSaveCartTemp() {
    const cart = this.cart();
    if (!cart || cart.length === 0) {
      return;
    }
    if (this.auth.currentUser()) {
      this.masterService.hideCartTemp();
      localStorage.removeItem(Constants.CartTemp);
      this.cartTemp.set([])
      const cartTemp = cart.map((x: any) => {
        return {
          l_CLASS_CD: x.l_CLASS_CD,
          s_CLASS_CD: x.s_CLASS_CD,
          servicE_CD: x.servicE_CD,
          quantity: x.quantity,
          membeR_NO: this.member()?.membeR_NO
        };
      });
      localStorage.setItem(Constants.CartTemp, JSON.stringify(cartTemp));
    }
    else {
      localStorage.removeItem(Constants.CartTemp);
      this.cartTemp.set([])
    }
  }


  memberLvlList = new Array();
  getMemberLvl() {
    const param = {
      P_HQ_CD: this.auth.getHQCD(),
      P_STR_CD: this.auth.getStrCd()
    }
    //SP_STR_GET_MEMBER_LVL
    this.masterService.excute_spNoLoading('6a839ca0-298d-11f1-9014-00155d001e02', param).then((res: any) => {
      if (res?.isOK) {
        this.memberLvlList = res?.result?.dataRes[0]?.rows;
      }
    })
  }

  storeInfo: any;
  getStoreInfo() {
    const param = {
      P_HQ_CD: this.auth.getHQCD(),
      P_STR_CD: this.auth.getStrCd()
    }
    //SP_STR_GET_INFO
    this.masterService.excute_spNoLoading('6a839b98-298d-11f1-9014-00155d001e02', param).then((res: any) => {
      if (res?.isOK) {
        this.storeInfo = res?.result?.dataRes[0]?.rows[0];
      }
    })
  }

  paymentReservation = signal<boolean>(false);
  getReservation(reservationDt: string, reservationNo: string) {
    if (reservationDt && reservationNo) {
      this.paymentReservation.set(true);
      const param = {
        P_HQ_CD: this.auth.getHQCD(),
        P_STR_CD: this.auth.getStrCd(),
        P_RESERVATION_DT: reservationDt,
        P_RESERVATION_NO: reservationNo
      }
      //SP_RESERVATION_DETAIL
      this.masterService.excute_sp('6a839afa-298d-11f1-9014-00155d001e02', param).subscribe((res: any) => {
        if (res?.isOK) {
          this.cart.set([])
          const data = res?.result?.dataRes[0]?.rows;
          data.forEach((element: any) => {
            this.addToCartReservation(element);
          });

          this.getMemberReservation(data[0]?.membeR_NO);
        }
      })
    }
  }

  cancelPaymentReservation() {
    this.paymentReservation.set(false);
    this.cart.set([]);
    this.reservationDt = "";
    this.reservationNo = "";
    this.member.set(null);
  }

  getMemberReservation(memberNo: string) {
    const param = {
      P_HQ_CD: this.auth.getHQCD(),
      P_STR_CD: this.auth.getStrCd(),
      P_MEMBER_NO: memberNo,
    }
    //SP_STR_GET_MEMBER_INFO
    this.masterService.excute_spNoLoading('6a839c37-298d-11f1-9014-00155d001e02', param).then((res: any) => {
      if (res?.isOK) {
        const data = res?.result?.dataRes[0]?.rows[0];
        this.member.set(data);
      }
    })
  }

  store = signal<any | null>(null);
  getStore() {
    const param = {
      P_HQ_CD: this.auth.getHQCD(),
      P_STR_CD: this.auth.getStrCd(),
      P_STR_NM: '',
      P_USE_YN: 'Y'

    }
    //SP_GET_STR_LIST
    this.masterService.excute_sp('6a83990a-298d-11f1-9014-00155d001e02', param).subscribe((res: any) => {
      if (res?.isOK) {
        this.store.set(res?.result?.dataRes[0]?.rows[0]);
      }
    })
  }

  checkBalance() {
    const param = {
      P_HQ_CD: this.auth.getHQCD(),
      P_STR_CD: this.auth.getStrCd(),
      P_TEL_NO: this.member().hP_NO
    }
    //SP_POP_MEMBER_LIST
    this.masterService.excute_sp('6a8399f1-298d-11f1-9014-00155d001e02', param).subscribe((res: any) => {
      if (res?.isOK) {
        this.masterService.showSuccess(this.translate.instant('ORDERSTR0016'))
        this.member.set(res?.result?.dataRes[0]?.rows[0]);
      }
    })
  }

  selectedUser = signal<string>('');
  ngOnDestroy() {
     this.masterService.hideCartTemp();
    this.onSaveCartTemp();
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: BeforeUnloadEvent) {
    $event.preventDefault();
    $event.returnValue = '';
  }

  resetIdempotencyKey() { this.productService.resetIdempotencyKey(); }
  loadData() {
    this.cart.set([])
    this.isDataLoading.set(true);
    this.productService.resetIdempotencyKey();
    setTimeout(() => {
      this.productService.getServices().then((res: any) => {
        if (res?.isOK) {
          if (res?.result?.dataRes) {
            this.posTabs.set(res?.result?.dataRes);

            this.selectCategory(res?.result?.dataRes[0])
            const products = res?.result?.dataRes
              ?.flatMap((e: any) => e.sclassdtOs
                ?.flatMap((s: any) => s.srmasterdtOs)
              ) || [];

            this.products.set(products);

            setTimeout(async () => {
              const temp = localStorage.getItem(Constants.CartTemp);
              if (temp && temp.length > 0) {
                this.cartTemp.set(JSON.parse(temp));
                await this.showConfirmCart();
              }
            }, 200);
          }
          this.getReservation(this.reservationDt, this.reservationNo)
        }
        this.isDataLoading.set(false);
      })
    }, 100);
  }

  // Computed Signals
  cartTotal = computed(() => this.cart().reduce((sum, item) => sum + (item.price * item.quantity), 0));
  totalPayment = computed(() => this.cartTotal() - this.DISCOUNT_AMT());
  DISCOUNT_AMT = computed(() => {
    const memberTp = this.member()?.membeR_TP;
    // membeR_FG: 1 giảm giá , 0 là tích điểm
    if (!memberTp || this.storeInfo?.membeR_FG !== "1") {
      return 0;
    }

    const level = this.memberLvlList?.find(x => x.membeR_TP === memberTp);

    if (!level) {
      return 0;
    }

    const rate = level.membeR_DICOUNT_RATE ?? 0;
    const total = this.cartTotal() ?? 0;

    return Math.trunc((rate * total) / 100);
  });

  filteredProducts = computed(() => {
    const term = this.searchTerm()?.trim().toLowerCase() ?? '';
    const allProducts = this.products();
    const category = this.selectedCategory();

    if (!allProducts?.length) return [];

    if (term) {
      return allProducts.filter((p: any) =>
        p?.servicE_NM?.toLowerCase().includes(term) ||
        p?.l_CLASS_CD?.toLowerCase().includes(term) ||
        p?.s_CLASS_CD?.toLowerCase().includes(term)
      );
    }

    if (!category) return allProducts;

    return allProducts.filter(
      (p: any) => p?.l_CLASS_CD === category.code
    );
  });

  currentGroups = computed(() => {
    const groupByCate = this.posTabs().filter((l: any) => l.l_CLASS_CD == this.selectedCategory()?.code);
    const groups =
      groupByCate.length > 0
        ? (groupByCate[0] as any).sclassdtOs?.map((p: any) => ({
          s_CLASS_CD: p.s_CLASS_CD,
          s_CLASS_NM: p.s_CLASS_NM,
        }))
        : [];
    return groups;
  });

  displayProducts = computed(() => {
    const products = this.filteredProducts();
    const group = this.selectedGroup();

    if (!group) return products;

    if (this.searchTerm()) {
      return products;
    }

    return products.filter(p => p?.s_CLASS_CD === group.code);
  });

  // Methods
  addToCartReservation(product: any) {
    this.refershCash();
    this.productService.resetIdempotencyKey();
    this.cart.update(prev => {
      const existing = prev.find((item: any) => item.servicE_CD === product.servicE_CD && item.l_CLASS_CD === product.l_CLASS_CD && item.s_CLASS_CD === product.s_CLASS_CD);
      product.l_ClassName = product.l_CLASS_NM;
      product.s_ClassName = product.s_CLASS_NM;
      product.quantity = product.salE_QTY;
      product.price = product.salE_UPRC;
      product.sr_tp = product.sR_TP;
      if (existing) {
        return prev.map((item: any) => item.servicE_CD === product.servicE_CD && item.l_CLASS_CD === product.l_CLASS_CD && item.s_CLASS_CD === product.s_CLASS_CD ? { ...item, quantity: item.quantity + product.quantity } : item);
      }
      return [...prev, { ...product, quantity: product.quantity, sr_tp: product.sr_tp }];
    });
  }

  addToCartTemp(product: any) {
    this.refershCash();
    this.productService.resetIdempotencyKey();

    const mainService = this.posTabs().find((x: any) => x.l_CLASS_CD === product.l_CLASS_CD) as any;
    const subService = mainService?.sclassdtOs.find((x: any) => x.s_CLASS_CD === product.s_CLASS_CD) as any;
    const service = subService?.srmasterdtOs.find((x: any) => x.servicE_CD === product.servicE_CD) as any;

    this.cart.update(prev => {
      product.l_ClassName = mainService?.l_CLASS_NM;
      product.s_ClassName = subService?.s_CLASS_NM;
      product.price = service?.price;
      product.sr_tp = mainService?.sR_TP;
      product.servicE_NM = service?.servicE_NM
      return [...prev, { ...product }];
    });
  }

  addToCart(product: any) {
    this.refershCash();
    this.productService.resetIdempotencyKey();
    this.cart.update(prev => {
      const existing = prev.find((item: any) => item.servicE_CD === product.servicE_CD && item.l_CLASS_CD === product.l_CLASS_CD && item.s_CLASS_CD === product.s_CLASS_CD);
      product.l_ClassName = this.selectedCategory()?.name;
      product.s_ClassName = this.selectedGroup()?.name;
      if (existing) {
        return prev.map((item: any) => item.servicE_CD === product.servicE_CD && item.l_CLASS_CD === product.l_CLASS_CD && item.s_CLASS_CD === product.s_CLASS_CD ? { ...item, quantity: item.quantity + 1 } : item);
      }
      return [...prev, { ...product, quantity: 1, sr_tp: this.selectedCategory()?.sr_tp }];
    });
  }

  updateQuantity(product: any, delta: number) {
    this.refershCash()
    this.productService.resetIdempotencyKey();
    this.cart.update(prev => prev.map((item: any) => {
      if (item.servicE_CD === product.servicE_CD && item.l_CLASS_CD === product.l_CLASS_CD && item.s_CLASS_CD === product.s_CLASS_CD) {
        return { ...item, quantity: Math.max(0, item.quantity + delta) };
      }
      return item;
    }).filter(item => item.quantity > 0));
  }

  updateQuantityInput(product: any, delta: number) {
    this.refershCash()
    this.productService.resetIdempotencyKey();
    this.cart.update(prev => prev.map((item: any) => {
      if (item.servicE_CD === product.servicE_CD && item.l_CLASS_CD === product.l_CLASS_CD && item.s_CLASS_CD === product.s_CLASS_CD) {
        return { ...item, quantity: Math.max(0, delta) };
      }
      return item;
    }).filter(item => item.quantity > 0));
  }

  removeFromCart(product: any) {
    this.refershCash();
    this.productService.resetIdempotencyKey();

    this.cart.update(prev =>
      prev.filter((item: any) =>
        !(
          item.servicE_CD === product.servicE_CD &&
          item.l_CLASS_CD === product.l_CLASS_CD &&
          item.s_CLASS_CD === product.s_CLASS_CD
        )
      )
    );
  }

  refershCash() {
    this.RECV_AMT = 0;
    this.Change_AMT = 0;
    this.mon_cnt = '00';
  }

  easyPayments = new Array();
  visibleEasypayment: boolean = false;
  selectedEasyPayment: any;
  getEasyPayment() {
    this.masterService.getCommNoLoading('ST28').then((res: any) => {
      if (res?.isOK) {
        this.easyPayments = res?.result?.dataRes[0]?.rows;
      }
    })
  }

  selectedEasyPay(type: any) {
    this.visibleEasypayment = false;
    this.selectedEasyPayment = type;
  }

  handlePaymentClick() {
    this.masterService.hideCartTemp();
    this.refershCash();
    if (this.cart().length === 0) return;
    const checkMainservice = this.cart().some(x => x.sr_tp === '0');
    if (checkMainservice) {
      if (this.easyPayments.length <= 0) this.getEasyPayment();
      this.getStore();
      this.viewMode.set('payment');
      this.paymentStep.set('selection');
      this.isMobileCartExpanded.set(false);
    }
    else {
      this.masterService.showError(this.translate.instant('ORDERSTR0010'))
      return;
    }
  }

  loading = signal(false);
  loadingText = signal('');
  setLoading(text: string) {
    this.loading.set(true);
    this.loadingText.set(text);
  }

  clearLoading() {
    this.loading.set(false);
    this.loadingText.set('');
  }

  onKeyDownMonCNT(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
    ];

    if (
      !/[0-9]/.test(event.key) &&
      !allowedKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  }

  onInputMonCNT(event: Event) {
    const input = event.target as HTMLInputElement;

    let value = input.value.replace(/[^0-9]/g, '');

    if (value === '') {
      this.mon_cnt = '';
      return;
    }

    value = value.slice(0, 2);

    const num = Number(value);

    if (num > 99) {
      value = '99';
    }

    // update lại nhưng GIỮ format
    input.value = value;
    this.mon_cnt = value;
  }

  async handleProcessPayment(cashType: number = 0) {
    if (this.selectedPaymentMethod() === this.paymentType.EasyPay && !this.selectedEasyPayment) {
      this.masterService.showError(this.translate.instant('PAYMESTR0057'))
      return;
    }
    if (this.selectedPaymentMethod() === this.paymentType.Cash && this.RECV_AMT < this.totalPayment()) {
      this.masterService.showError(this.translate.instant('PAYMESTR0055'))
      return;
    }
    const param = {
      paymentType: this.selectedPaymentMethod(),
      membeR_NO: this.member()?.membeR_NO,
      user_Id: this.selectedUser(),
      cash_type: cashType,
      mon_cnt: this.mon_cnt,
      RECV_AMT: this.RECV_AMT,
      reservatioN_DT: this.reservationDt,
      reservatioN_NO: this.reservationNo,
      Carts: this.cart()
    }
    // this.productService.addSale(param).subscribe({
    //   next: (res: any) => {
    //     if (!res?.isOK) {
    //       this.resetIdempotencyKey();
    //       var errCode = res?.errorMessages[0]?.errorCode || res?.ErrorMessages[0]?.ErrorCode;
    //       if (errCode === "RECPTSTR0086") {
    //         this.clearCartTemp();
    //         this.paymentStep.set('complete');
    //       }
    //       this.masterService.showError(Constants.showError(res?.errorMessages ?? res?.ErrorMessages))
    //     }
    //     else {
    //       this.clearCartTemp();
    //       this.paymentStep.set('complete');
    //     }
    //   },
    //   error: (err) => {
    //     this.resetIdempotencyKey();
    //     this.masterService.showError(this.translate.instant('RECPTSTR0104'))
    //   }
    // })
    this.productService.addSale(param).subscribe(async (res: any) => {
      if (res?.isOK || res?.IsOK) {
        const paramWs = res?.result?.dataRes;
        const pendingId = res?.result?.dataRes?.pendingId
        if (this.selectedPaymentMethod() === this.paymentType.Card || cashType === this.paymentType.CashBill) {
          this.setLoading(this.translate.instant('SYSMESER0031'));
          try {
            const res = await this.webSocket.sendMessage(paramWs);
            const vanRespone = JSON.parse(res?.vanRespone);
            this.setLoading(this.translate.instant('SYSMESER0030'));
            const message = `${vanRespone?.MSG_1}.${vanRespone?.MSG_2}`
            this.ksNet.peymentSuccessNoLoading(vanRespone, pendingId).then(async (res: any) => {
              if (res?.isOK) {
                this.setLoading(this.translate.instant('SYSMESER0029'));
                const paramPrintWs = res?.result?.dataRes;
                try {
                  const res = await this.webSocket.sendMessage(paramPrintWs, 5000);
                  const printRespone = JSON.parse(res?.printRespone);
                  if (!printRespone?.Success) {
                    this.masterService.showError(this.translate.instant('RECPTSTR0086'))
                  }
                  this.setComplete();
                } catch (err) {
                  this.setComplete();
                  this.masterService.showError(this.translate.instant('AGENTSTR0001'))
                }
              }
              else {
                this.resetIdempotencyKey();
                this.clearLoading();
                // this.paymentStep.set('complete');
                // this.masterService.showError(this.translate.instant('RECPTSTR0103'))
                this.masterService.showError(message)
              }
            })
          } catch (err) {
            this.resetIdempotencyKey();
            this.clearLoading();
            this.masterService.showError(this.translate.instant('AGENTSTR0001'))
          }
        }
        else {
          this.setLoading(this.translate.instant('SYSMESER0029'));
          try {
            const res = await this.webSocket.sendMessage(paramWs, 5000);
            const printRespone = JSON.parse(res?.printRespone);
            if (!printRespone?.Success) {
              this.masterService.showError(this.translate.instant('RECPTSTR0086'))
            }
            this.setComplete();
          } catch (err) {
            this.setComplete();
            this.masterService.showError(this.translate.instant('AGENTSTR0001'))
          }
        }
      }
      else {
        this.clearLoading();
        this.masterService.showError(Constants.showError(res?.errorMessages ?? res?.ErrorMessages))
      }
    })
  }

  setComplete() {
    this.clearCartTemp();
    this.clearLoading();
    this.paymentStep.set('complete');
  }


  clearCartTemp() {
    this.cart.set([]);
    if (this.isPaymentTemp) {
      this.cartTemp.set([])
      localStorage.removeItem(Constants.CartTemp)
    }
  }

  handleCompleteClose() {
    this.cart.set([]);
    this.selectedEasyPayment = null;
    this.RECV_AMT = 0;
    this.mon_cnt = '00';
    this.isMobileCartExpanded.set(false);
    this.paymentStep.set('selection');
    this.viewMode.set('register');
    this.productService.resetIdempotencyKey();
    this.member.set(null);
    this.cdr.detectChanges();
  }

  selectGroup(group: any) {
    const g = {
      code: group?.s_CLASS_CD,
      name: group?.s_CLASS_NM,
      sr_tp: '0'
    }
    this.selectedGroup.set(g);
  }

  selectCategory(category: any) {
    this.selectedCategory.set({
      name: category?.l_CLASS_NM,
      code: category?.l_CLASS_CD,
      sr_tp: category?.sR_TP
    });
    this.searchTerm.set('');
    // Explicitly set the group to the first available one for the new category.
    const groups = this.currentGroups() as any;
    if (groups.length > 0) {
      this.selectGroup(groups[0])
    }
  }

  startSearch() {
    if (!this.searchTerm()) {
      this.searchTerm.set(' ');
      // A little trick to ensure the input field appears before we focus it
      setTimeout(() => {
        const input = document.getElementById('searchInput');
        input?.focus();
      }, 0);
    }
  }

  clearSearch() {
    this.searchTerm.set('');
  }

  closeMemberSearch() {
    this.openMemberSearch.set(false);
  }


  onPhoneInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const original = input.value;
    input.value = original.replace(/[eE\+\-]/g, '');
    input.value = input.value.replace(/[^0-9]/g, '');

    if (input.value.length <= 10) {
      input.value = input.value.replace(/(\d{3})(\d{3})(\d{0,4})/, (_, a, b, c) => {
        return c ? `${a}-${b}-${c}` : `${a}-${b}`;
      });
    } else {
      input.value = input.value.substring(0, 11);
      input.value = input.value.replace(/(\d{3})(\d{4})(\d{0,4})/, (_, a, b, c) => {
        return c ? `${a}-${b}-${c}` : `${a}-${b}`;
      });
    }
  }
}
